import {
	Logo,
	NavItemAccount,
	NavItemBookmarks,
	NavWidgetTel,
} from "@launerlondon/shop-components";
import { routes } from "@launerlondon/shop-router";
import { NavLink } from "react-router";
import {
	Breadcrumb,
	CartWidget,
	LocaleSelectorWidget,
	Menu,
	MenuMobile,
} from "../components";
import SearchField from "../components/SearchField";
import { twJoin } from "tailwind-merge";

const Header: React.FC = () => {
	return (
		<>
			<div className="container relative mb-2 mt-6 flex items-center justify-center lg:my-4">
				<NavLink
					to={routes.home}
					className={twJoin(
						"relative",
						"block",
						//"max-lg:mx-auto max-lg:flex-1",
						//"lg:m-auto lg:my-2",
						"aspect-[6/3] h-16 md:h-20 lg:h-24",
						//"absolute bottom-0 left-1/2 translate-x-1/2",
					)}
				>
					<Logo className="absolute inset-0" />
					<div className="sr-only">
						Launer London - Innovators of customisation
					</div>
				</NavLink>
				<NavLink
					to={routes.royalWarrant}
					className="absolute right-2 lg:mt-10"
				>
					<figure>
						<div
							className={twJoin(
								"mx-auto",
								"aspect-[4/3] h-16 md:h-20",
								"mask-contain mask-center mask-no-repeat",
								"mask-[url('/images/royal-warrant.webp')]",
								"bg-[#B9AE88]",
							)}
						/>
						<figcaption className="sr-only">
							By appointment to Her Majesty The Queen.
							Manufacturers of handbags and leather goods, Launer
							London.
						</figcaption>
					</figure>
				</NavLink>
			</div>
			<div className="relative sticky top-0 z-40 mx-auto w-full lg:static">
				<div
					className={twJoin(
						"container flex flex-wrap items-center",
						"justify-between gap-4 py-2 lg:justify-end lg:gap-0 lg:py-0",
					)}
				>
					<NavWidgetTel className="absolute left-10 top-2" />
					<MenuMobile className="lg:hidden" />
					<Menu className="hidden lg:flex" />
					<div
						className={twJoin(
							"lg:fixed lg:top-2",
							"flex items-center gap-4",
							"rounded-full bg-white/90 p-2",
						)}
					>
						<LocaleSelectorWidget />
						<SearchField />
						<CartWidget />
						<NavItemBookmarks />
						<NavItemAccount className="hidden lg:block" />
					</div>
				</div>
			</div>
			<Breadcrumb />
		</>
	);
};

export default Header;
